import Vue from "vue";
import Vuex from "vuex";
// import createPersistedState from 'vuex-persistedstate'
import { ProfileStore } from "./ProfileStore/ProfileStore.js";

Vue.use(Vuex);

const state = {
    dupphone: {}, 
    location: {},
    userlevel: {currentTierRange:{}},
    usersubscription: {
        campaign: {},
        detail: {}
    },
    isAppLoad: false,
}

// const plugins = [
//     createPersistedState()
// ]

const mutations = {
    Loading(state, value) {
        state.isAppLoad = value;
    },
    setDupphone(state, dupphone) {
        state.dupphone = dupphone;
    },
    setLocation(state, location) {
        state.location = location;
    },
    setUserSubscription(state, usersubscription) {
        state.usersubscription.detail = usersubscription;
    },
    setCampaignSubscription(state, campaignsubscription) {
        state.usersubscription.campaign = campaignsubscription;
    },
    setUserlevel(state, userlevel) {
        state.userlevel = userlevel;
    }
}

const actions = {
    setLocation: (context, payload) => {
        context.commit('setLocation', payload);
    },
    setUserSubscription: (context, payload) => {
        context.commit('setUserSubscription', payload);
    },
    setCampaignSubscription: (context, payload) => {
        context.commit('setCampaignSubscription', payload);
    },
    setUserlevel: (context, payload) => {
        context.commit('setUserlevel', payload);
    },
}

const getters = {
    getLocationStore: state => state.location,
    getUserSubscription: state => state.usersubscription,
    getUserlevel: state => state.userlevel,
}

const modules = {
    profile: ProfileStore
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules,
    // plugins
})

